import classNames from 'classnames';
import React from 'react';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-4';

type PaginationProps = {
  currentPage: number;
  transparent?: boolean;
  className?: string;
  floating?: boolean;
  totalPages: number;
  onChange: (page: number) => void;
};

export default function Pagination({
  currentPage,
  transparent = false,
  className,
  floating = false,
  totalPages,
  onChange,
}: PaginationProps) {
  if (!totalPages || totalPages <= 1) return null;

  const wrapperClasses = classNames(
    'd-flex justify-content-center py-3',
    {
      'bg-transparent': transparent,
      'border rounded shadow bg-white': floating && !transparent,
      'border-top bg-white': !floating && !transparent,
    },
    className
  );

  return (
    <div className={wrapperClasses}>
      <UltimatePagination
        currentPage={currentPage}
        totalPages={totalPages}
        onChange={onChange}
      />
    </div>
  );
}

